/*  Product-page Phosphor icon registry.
    ─────────────────────────────────────────────────────────────
    JSON arrays in `cms_content` store icons by name (e.g. "Tooth").
    Product-page renderers resolve that string to the actual React
    component via `resolveIcon`. Unknown names fall back to `ShieldStar`
    so a bad admin edit never crashes the page.

    When marketing wants a new icon added to the CMS palette, register
    it here — one line — and it's live.
*/
import {
    Tooth, Smiley, Fingerprint, Stethoscope, ShieldStar, ShieldCheck,
    HandHeart, Moon, Bed, Wind, Certificate, TestTube, Flask, Star,
    Warning, Waveform, Sparkle, MapPin, CheckCircle, XCircle,
    Heart, Brain, Alarm, Lightning, Trophy, Timer, Barbell,
    Football, Basketball, PersonSimpleRun,
    Diamond, Recycle, Infinity as InfinityIcon, Crown, CalendarCheck,
    Note, Pulse, Quotes, Archive, ClipboardText,
    SealCheck, Calculator, Confetti,
} from "@phosphor-icons/react";


const ICONS = {
    Tooth, Smiley, Fingerprint, Stethoscope, ShieldStar, ShieldCheck,
    HandHeart, Moon, Bed, Wind, Certificate, TestTube, Flask, Star,
    Warning, Waveform, Sparkle, MapPin, CheckCircle, XCircle,
    Heart, Brain, Alarm, Lightning, Trophy, Timer, Barbell,
    Football, Basketball, PersonSimpleRun,
    Diamond, Recycle, Infinity: InfinityIcon, Crown, CalendarCheck,
    Note, Pulse, Quotes, Archive, ClipboardText,
    SealCheck, Calculator, Confetti,
};


export function resolveIcon(name, fallback = ShieldStar) {
    if (!name) return fallback;
    return ICONS[name] || fallback;
}


export default ICONS;
